export default __webpack_public_path__ + "static/media/dynaslope_seal2.54834eb6.png";